<template>
    <div id="footer">

        <footer class="site-footer">
            <div class="footer-inner">
                <div class="footer-grid">
                    <!-- 公司信息 -->
                    <div class="footer-col">
                        <div class="footer-logo">
                            <img src="../assets/images/login_logo.png" class="img-auto" alt="">
                        </div>
                        <p class="footer-desc">
                            {{ $isZh ? '专注于中国旅游服务十余年，为全球旅行者提供专业、贴心的中国旅行定制服务。' : 'Focusing on Chinese tourism services for over ten years, we provide professional and thoughtful customized Chinese travel services for global travelers.'}}
                        </p>
                        <!-- <p class="footer-beian">{{ $t('footer.RegistrationNumber') }}-91440300MAEMRJ0P6C</p> -->
                    </div>

                    <!-- 友情链接 -->
                    <div class="footer-col">
                        <ul class="footer-links">
                            <li v-for="(item, index) in data_system_data" :key="index">
                                <router-link :to="'/richTextPage?type_id=' + item.type">{{ $t(item.title)
                                    }}</router-link>
                            </li>
                        </ul>
                    </div>

                    <!-- 联系我们 -->
                    <div class="footer-col">
                        <h4 class="footer-heading">{{ $isZh ? '联系我们' : 'Contact Us' }}</h4>
                        <ul class="footer-contact">
                            <li>
                                <span class="iconfont icon-lujingbeifen3"></span>
                                <span>{{ $t('footer.serviceHotline') }}：{{ data_tel.post_content }}</span>
                            </li>
                            <li>
                                <span class="iconfont icon-youxiang-"></span>
                                <span>sales@cntenghaitour.com</span>
                            </li>
                             <li>
                                <span class="iconfont icon-youxiang-" style="color: transparent;"></span>
                                <span>chinadmcb2b@cntenghaitour.com</span>
                            </li>
                            <li>
                                <span class="iconfont icon-xukezheng "></span>
                                <span>{{ $t('footer.TravelAgencyLicense') }}L-GD-103265</span>
                            </li>
                        </ul>
                        <!-- 客服二维码 -->
                        <div class="qr-code">
                            <div class="qr-placeholder">
                                <img src="../assets/images/qr2.png" alt="">
                                <img src="../assets/images/qr.png" alt="">
                            </div>

                        </div>

                    </div>

                    <!-- 社交平台 & WhatsApp -->
                    <div class="footer-col">
                        <h4 class="footer-heading">{{ $isZh ? '关注我们' : 'Follow us' }}</h4>
                        <div class="social-links">
                            <!-- 微信 (绿色) -->
                            <a href="#" class="social-link" title="微信" style="color: #3AC34C;">
                               <span class="iconfont icon-weixin"></span>
                            </a>

                            <!-- 微博 (红色渐变) -->
                            <a href="#" class="social-link" title="微博" style="color: #E71F19;">
                                <span class="iconfont icon-weibo"></span>
                            </a>

                            <!-- 抖音 (黑色) -->
                            <a href="#" class="social-link" title="抖音" style="color: #000000;">
                                <span class="iconfont icon-douyin"></span>
                            </a>

                            <!-- Instagram (渐变色) -->
                            <a href="#" class="social-link" title="Instagram" style="color: #FF0000;">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
                                </svg>
                            </a>

                            <!-- YouTube (红色) -->
                            <a href="#" class="social-link" title="YouTube" style="color: #FF0000;">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                </svg>
                            </a>
                        </div>

                        <!-- WhatsApp 按钮 (绿色) -->
                        <a href="https://wa.me/8614776148891" class="whatsapp-btn" target="_blank" rel="noopener"
                            style="background-color: #25D366; color: white;">
                            <svg viewBox="0 0 24 24" fill="currentColor" class="wa-icon">
                                <path
                                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
                            </svg>
                            <span>WhatsApp</span>
                        </a>
                    </div>
                </div>

                <div class="footer-bottom">
                    <p>© 2026 Tenghai Travel</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    props: ['data_system', 'data_tel'],
    mounted() {

    },


    methods: {

    },

    computed: {
        data_system_data() {
            let arr = []
            // ✅ 加上这个判断：如果数据不存在或不是数组，直接返回空数组
            if (!this.data_system || !Array.isArray(this.data_system)) {
                return [];
            }

            this.data_system.forEach((item, index) => {
                let obj = {}
                if (item.type == '1') {
                    obj['title'] = 'footer.aboutUs'
                    obj['id'] = item.id
                    obj['type'] = item.type
                    arr.push(obj)
                }
                if (item.type == '2') {
                    obj['title'] = 'footer.companyIntroduction'
                    obj['id'] = item.id
                    obj['type'] = item.type
                    arr.push(obj)
                }
                if (item.type == '3') {
                    obj['title'] = 'footer.branchManagement'
                    obj['id'] = item.id
                    obj['type'] = item.type
                    arr.push(obj)
                }
                // if (item.type == '4') {
                //     obj['title'] = 'footer.aboutUs'
                //     obj['id'] = item.id
                // }
                if (item.type == '5') {
                    obj['title'] = 'footer.detailedTourismRules'
                    obj['id'] = item.id
                    obj['type'] = item.type
                    arr.push(obj)
                }
                if (item.type == '6') {
                    obj['title'] = 'footer.paymentMethod'
                    obj['id'] = item.id
                    obj['type'] = item.type
                    arr.push(obj)
                }
                // if (item.type == '7') {
                //     obj['title'] = 'footer.aboutUs'
                //     obj['id'] = item.id
                // }

            })

            return arr

        }
    }
}

</script>


<style lang="scss" scoped>
#footer {}

/* ==================== Footer ==================== */
.site-footer {
    background: linear-gradient(135deg, #0d3b66 0%, #1a6db5 100%);
    padding: 60px 0 0;
}

.footer-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 1.3fr 0.8fr 1fr 1fr;
    gap: 40px;
    padding-bottom: 40px;
}

.footer-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    width: 322px;
    height: 70px;
}

.footer-logo .logo-icon {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
}

.footer-logo .logo-text {
    color: #ffffff;
}

.footer-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.7;
    margin-bottom: 16px;
}

.footer-company-name {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    margin-bottom: 4px;
}

.footer-beian {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
}

.footer-heading {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #ffffff;
}

.footer-links li {
    margin-bottom: 10px;
}

.footer-links a {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    transition: color var(--transition);
}

.footer-links a:hover {
    color: #ffffff;
}

.footer-contact li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 16px;
    color: #fff;
}

.footer-contact li .iconfont {
    font-size: 26px;
    color: rgb(255, 61, 61);
}

/* QR code */
.qr-code {
    margin-top: 20px;
    text-align: center;
    display: flex;
}

.qr-placeholder-wx {
    /* display: flex; */
    /* flex-direction: column; */
}

.qr-placeholder {
    width: 100%;
    height: 100px;
    /* background: rgba(255, 255, 255, 0.1); */
    /* border: 1px solid rgba(255, 255, 255, 0.2); */
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 10px 8px 0;
}

.qr-placeholder img {
    width: 120px;
    height: 120px;
    margin-right: 10px;

}

.qr-label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.55);
}

/* Social links */
.social-links {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.social-link {
    width: 40px;
    height: 40px;
    background: #fff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.8);
    font-size: 25px;
    transition: all var(--transition);
}

.social-link:hover {
    background: #ffffff;
    border-color: #ffffff;
    color: var(--accent);
}

.social-link svg {
    width: 18px;
    height: 18px;
}

/* WhatsApp button */
.whatsapp-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: #25d366;
    color: #ffffff;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    transition: all var(--transition);
}

.whatsapp-btn:hover {
    background: #20bd5a;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.3);
}

.wa-icon {
    width: 20px;
    height: 20px;
}

/* Footer bottom */
.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px 0;
    text-align: center;
}

.footer-bottom p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
}
</style>